export const ALARMS_TYPES = {
  SYSTEM: 'System Offline',
  GATEWAY: 'Gateway Offline',
  SENSOR: 'Sensor Offline',
  FLOW_SENSOR: 'Flow Sensor Offline',
  TEMP_SENSOR: 'Temperature Sensor Offline',
  FLOW_SENSOR_S: 'Flow Sensor(s) Offline',
  TEMP_SENSOR_S: 'Temperature Sensor(s) Offline',
  TEMPERATURE: 'Temperature',
  POUR: 'Pour',
};

export const ALARM_OFFLINE_TYPES = [
  ALARMS_TYPES.SYSTEM,
  ALARMS_TYPES.GATEWAY,
  ALARMS_TYPES.SENSOR,
  ALARMS_TYPES.FLOW_SENSOR,
  ALARMS_TYPES.TEMP_SENSOR,
  ALARMS_TYPES.FLOW_SENSOR_S,
  ALARMS_TYPES.TEMP_SENSOR_S,
];

export const CONDITION_OFFLINE_TYPES = [
  ALARMS_TYPES.SYSTEM,
  ALARMS_TYPES.FLOW_SENSOR_S,
  ALARMS_TYPES.TEMP_SENSOR_S,
];

export const HOME_CONDITION_OFFLINE_TYPES = [
  ALARMS_TYPES.SYSTEM,
  ALARMS_TYPES.FLOW_SENSOR_S,
  ALARMS_TYPES.TEMP_SENSOR_S,
];
